import React from 'react'

import { Visit } from 'components/Icons'
import { SegmentGroup } from 'components/Common'

export const BookVisit = ({ linkTo = '/providers' }) => {
  return (
    <SegmentGroup
      icon={<Visit width={27} height={27} />}
      title='Book a Visit'
      description='Get care when and where you need it — online, by phone, in-person.'
      linkTo={linkTo}
      linkText='Get started >'
    />
  )
}
